/**
  @param selector {string]  验证码的css选择器
  @param w {number} 验证码的宽
  @param h {number} 验证码的高
  @param count {number} 数字的个数
  @return {array} 验证码数字组成的数组
*/
function createVerifCode(selector, w, h, count) {
    var canvas = document.querySelector(selector);
    var i, num;
    var unit = Math.round(w / count); // 等量划分宽度
    var result = [];
    if(!canvas) {
        return;
    }
    // 设置画布宽度
    canvas.width = w; 
    canvas.height = h;
    // 获取画布的执行上下文
    var ctx = canvas.getContext('2d');
    // 绘制背景部分
    drawBg();
    // 生成验证码数字部分
    for(i = 1; i <= count; i++) {
        num = Math.round(Math.random()*9);
        result.push(num);
        // 绘制数字部分
        drawNumber(num, i);
    }
    return result;
    // 使用外部ctx
    function drawNumber (num, i) {
        var fontSize = 20;
        var pos = createPos(fontSize, i);
        ctx.beginPath();
        ctx.fillStyle = createColor(0);
        ctx.font = fontSize + 'px serif'; // 没有serif不生效
        ctx.fillText(num, pos[0], pos[1]);
        ctx.fill();
        ctx.closePath();
    }
    // 生成随机颜色
    function createColor(type = 1) {
        var colorUnit = [[0,1,2,3,4,5],['a', 'b', 'c', 'd', 'e','f']];
        var colorCode = '#';
        var i, randomNum;
        for(i = 0; i < 6; i++) {
            randomNum = colorUnit[type][Math.round(Math.random()*5)];
            colorCode += randomNum;
        }
        return colorCode;
    }
    // 生成随机位置 unit来自外部
    function createPos(fontSize, i) {
        var x = randNum((i-1)*unit, i*unit-fontSize);
        var y = randNum(fontSize, h);
        return [x, y];
    }
    // 描绘背景
    function drawBg() {
        // 矩形背景颜色填充
        ctx.beginPath();
        ctx.fillStyle = createColor();
        ctx.fillRect(0, 0, w, h);
        ctx.fill();
        ctx.closePath();
        // 圆点点缀
        
        var circleColor = createColor();
        ctx.fillStyle = circleColor;
        var j = 6;
        while(j <= h) {
            var i = 6;
            while(i <= w) {
                drawCircle(i, j, 2);
                i+=10;
            }
            j+=20;
        }
    } 
    // 画圆点
    function drawCircle(x, y, r) {
        ctx.beginPath();
        ctx.arc(x, y, r, 0, 2*Math.PI);
        ctx.fill();
        ctx.closePath();
    }
    // 生成指定范围随机数
    function randNum(minnum , maxnum) {
        return Math.floor(minnum + Math.random() * (maxnum - minnum));
    }
}

export { createVerifCode };